import { SITE_COLORS, SITE_TEXT_PRESETS } from './theme';
export const getStyle = (style)=>({
        ...style,
        styleParams: {
            colors: style?.styleParams?.colors ?? {},
            booleans: style?.styleParams?.booleans ?? {},
            numbers: style?.styleParams?.numbers ?? {},
            fonts: style?.styleParams?.fonts ?? {},
            googleFontsCssUrl: ''
        },
        siteColors: SITE_COLORS,
        siteTextPresets: SITE_TEXT_PRESETS
    });

//# sourceMappingURL=get-style.js.map